import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../find-polyfill';

import { findTaxonomyObjectByID } from '../helpers';

class ActiveFilterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilters: [],
    };
  };

  handleFilterClick(filter) {
    this.props.applyFilter({
      action: 'deactivate',
      obj: filter,
    });
  };

  render() {
    const orderedActiveFilterList = this.props.orderedActiveFilterList;

    let classList = [];
    // Add class names to active filters
    for (let i=0; i<orderedActiveFilterList.length; i++) {
      if (orderedActiveFilterList[i].type === 'taxonomy') {
        if (orderedActiveFilterList[i].taxonomy.name === 'topics') {
          // Get list of topics from wpData
          function istopics(obj) { return obj.name === 'topics'; }
          let wpTopics = this.props.wpData.taxonomies.find(istopics);

          let topicClassName = 'ActiveFilterList__filter--' + orderedActiveFilterList[i].obj.slug;
          if (orderedActiveFilterList[i].relation === 'child') { // Check if this is a child topic term (for color application purposes they get the same class name as their parent)
            let topicParent = findTaxonomyObjectByID(orderedActiveFilterList[i].parent, wpTopics.terms);
            if (typeof topicParent !== 'undefined') {
              topicClassName = 'ActiveFilterList__filter--' + topicParent.slug;
            }
          }
          classList.push(topicClassName);
        }
        else {
          classList.push('ActiveFilterList__filter');
        }
      }
      else {
        classList.push('ActiveFilterList__filter');
      }
    }

    if (orderedActiveFilterList.length > 0) {
      return (
        <ul className="ActiveFilterList">
        {orderedActiveFilterList.map((filter, index) => // Loop through posts and display them
          <li key={index}><button className={classList[index]} onClick={ function() {this.handleFilterClick(filter); }.bind(this)}>{filter.label}</button></li>
        )}
        </ul>
      );
    }
    else {
      return null;
    }
  };
}

ActiveFilterList.propTypes = {
  applyFilter: PropTypes.func,
  orderedActiveFilterList: PropTypes.array,
  wpData: PropTypes.object,
};

export default ActiveFilterList;


// WEBPACK FOOTER //
// ./src/components/ActiveFilterList.js